import ApiClient from './ApiClient';

export const getBreakId = async (): Promise<any> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const response = await ApiClient.get(`/v1/business/attendBreak/${companyCode}`, {}, {});
  return response.data;
};